import type { Room } from "./roomTypes";

// the order of these is important. If modifying, leave NONE as the first item
// or explicitly set NONE = 0
export enum RoomConnectionType {
  NONE = 0,
  OPEN,
  OPEN_EXTERIOR,
}

export interface RoomConnection {
  roomIndexOnLevel: number | undefined;
  connectionType: RoomConnectionType;
  halfEdge: number;
}

export type RoomSet = Room[];
